import { GetUserSettingsQuery } from "gql/generated/types";
import { useMemo } from "react";
import { MdmTableName } from "../utils/types";

const useUserTableDetails = (
  userSettingsQuery: GetUserSettingsQuery | undefined,
  tableName: MdmTableName
) => {
  const userTableDetails = useMemo(
    () => userSettingsQuery?.userSettings.tablesDetails?.find(r => r?.table === tableName),
    [userSettingsQuery, tableName]
  );

  return userTableDetails;
};

export default useUserTableDetails;
